import script from "./ContactSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactSection.vue?vue&type=script&setup=true&lang=ts"

import "./ContactSection.vue?vue&type=style&index=0&id=9bac4d6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bac4d6c"]])

export default __exports__